export default __webpack_public_path__ + "static/media/editImg.829f9995.png";